const settingsConfig = {
    layout: {
        style: 'layout2', // layout-1 layout-2 layout-3
        config: {} // checkout layout configs at app/fuse-configs/layout-1/Layout1Config.js
    },
    customScrollbars: true,
    theme: {
        main: 'azul_claro',
        navbar: 'azul_claro',
        toolbar: 'azul_claro',
        footer: 'azul_claro'
    },
};

export default settingsConfig;
